import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const SiouxFalls = () => {
  useEffect(() => {
    document.title = 'We Buy Valves Sioux Falls | Industrial Equipment Buyers Sioux Falls South Dakota';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Leading valve and instrumentation buyer serving Sioux Falls and Eastern South Dakota ethanol production, food processing, and agricultural manufacturing facilities. Same-day response, competitive pricing.');
    }
    
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'we buy valves sioux falls, sioux falls valve buyers, south dakota industrial equipment buyers, ethanol plant valves, poet biorefining equipment');
    
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/cities/sioux-falls');
    
    const ogTags = [
      { property: 'og:title', content: 'We Buy Valves Sioux Falls | Industrial Equipment Buyers Sioux Falls South Dakota' },
      { property: 'og:description', content: 'Leading valve and instrumentation buyer serving Sioux Falls and Eastern South Dakota ethanol production, food processing, and agricultural manufacturing facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/cities/sioux-falls' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    let geoPosition = document.querySelector('meta[name="geo.position"]');
    if (!geoPosition) {
      geoPosition = document.createElement('meta');
      geoPosition.setAttribute('name', 'geo.position');
      document.head.appendChild(geoPosition);
    }
    geoPosition.setAttribute('content', '43.5460;-96.7313');
    
    let geoRegion = document.querySelector('meta[name="geo.region"]');
    if (!geoRegion) {
      geoRegion = document.createElement('meta');
      geoRegion.setAttribute('name', 'geo.region');
      document.head.appendChild(geoRegion);
    }
    geoRegion.setAttribute('content', 'US-SD');
    
    let geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (!geoPlacename) {
      geoPlacename = document.createElement('meta');
      geoPlacename.setAttribute('name', 'geo.placename');
      document.head.appendChild(geoPlacename);
    }
    geoPlacename.setAttribute('content', 'Sioux Falls, South Dakota');
    
    let lastModified = document.querySelector('meta[http-equiv="last-modified"]');
    if (!lastModified) {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('http-equiv', 'last-modified');
      document.head.appendChild(lastModified);
    }
    lastModified.setAttribute('content', new Date().toISOString());

    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply Sioux Falls",
          "image": "https://valvesalessupply.com/logo.png",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Sioux Falls",
            "addressRegion": "SD",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 43.5460,
            "longitude": -96.7313
          },
          "telephone": "+1-214-854-5638",
          "email": "valvesalessupply@gmail.com",
          "url": "https://valvesalessupply.com/cities/sioux-falls",
          "priceRange": "$$",
          "areaServed": {
            "@type": "City",
            "name": "Sioux Falls",
            "addressRegion": "SD"
          },
          "description": "Leading valve and instrumentation buyer serving Sioux Falls and Eastern South Dakota ethanol production, food processing, and agricultural manufacturing facilities."
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of ethanol plant valves do you buy in Sioux Falls?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase all types of ethanol production valves including ball valves, butterfly valves, control valves, and process instrumentation from POET Biorefining and other Sioux Falls area ethanol facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy equipment from food processing plants in Sioux Falls?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we regularly purchase surplus equipment from Smithfield Foods and other food processing facilities throughout Sioux Falls and Eastern South Dakota."
              }
            },
            {
              "@type": "Question",
              "name": "How fast can you respond in Sioux Falls?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide same-day response for Sioux Falls facilities with 24-hour quotes for all equipment types and project sizes."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "South Dakota",
              "item": "https://valvesalessupply.com/south-dakota"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Sioux Falls",
              "item": "https://valvesalessupply.com/cities/sioux-falls"
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-b from-[#1B3A5F] to-[#2B4A6F]">
        <div className="max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-5xl font-bold mb-6">We Buy Valves Sioux Falls</h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Leading valve and instrumentation buyer serving Sioux Falls and Eastern South Dakota's 
            ethanol production, food processing, and agricultural manufacturing facilities.
          </p>
        </div>
      </section>

      {/* Quick Contact Bar */}
      <section className="bg-white py-6 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center">
              <i className="ri-map-pin-line text-[#1B3A5F] text-2xl mr-3"></i>
              <span className="text-gray-700 font-semibold">Serving Sioux Falls &amp; Eastern South Dakota</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-[#1B3A5F] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#2B4A6F] transition-all duration-300 flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                (214) 854-5638
              </a>
              <a
                href="mailto:siouxfalls@valvesalessupply.com"
                className="border-2 border-[#1B3A5F] text-[#1B3A5F] px-6 py-3 rounded-full font-semibold hover:bg-[#1B3A5F] hover:text-white transition-all duration-300 flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                Email Sioux Falls Team
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">
                Sioux Falls Industrial Equipment Buyers
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Valve Sales Supply provides professional equipment purchasing services to Sioux Falls' 
                growing industrial sector, including ethanol production facilities, food processing plants, 
                and agricultural manufacturing operations throughout Eastern South Dakota.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Our team specializes in acquiring surplus valves, instrumentation, and process control 
                equipment from facility upgrades, plant closures, and equipment modernization projects 
                across the region's diverse manufacturing base.
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                {[
                  'Same-Day Response',
                  '24-Hour Quotes',
                  'Professional Removal',
                  'Fair Market Pricing',
                  'Complete Documentation',
                  'Licensed &amp; Insured'
                ].map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3 text-xl"></i>
                    <span className="text-gray-700 font-semibold">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="rounded-3xl overflow-hidden shadow-lg">
              <img 
                src="https://public.readdy.ai/ai/img_res/a2107d7c719d71fcc429857464971703.jpg"
                alt="Sioux Falls Industrial Area"
                className="w-full h-96 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Major Facilities Served */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Sioux Falls Facilities We Serve
            </h2>
            <p className="text-gray-600 text-xl">
              Supporting Eastern South Dakota's industrial and manufacturing sectors
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                name: 'POET Biorefining',
                type: 'Ethanol Production',
                icon: 'ri-plant-line',
                description: 'Major ethanol producer with multiple facilities'
              },
              {
                name: 'Smithfield Foods',
                type: 'Food Processing',
                icon: 'ri-restaurant-line',
                description: 'Large-scale meat processing operations'
              },
              {
                name: 'Sioux Falls Steel',
                type: 'Metal Fabrication',
                icon: 'ri-tools-line',
                description: 'Structural steel and metal manufacturing'
              },
              {
                name: 'Raven Industries',
                type: 'Advanced Manufacturing',
                icon: 'ri-settings-3-line',
                description: 'Precision manufacturing and technology'
              },
              {
                name: 'Sencore',
                type: 'Electronics Manufacturing',
                icon: 'ri-cpu-line',
                description: 'Test equipment and electronics production'
              },
              {
                name: 'Regional Ethanol Plants',
                type: 'Biofuel Production',
                icon: 'ri-flask-line',
                description: 'Multiple ethanol facilities in surrounding area'
              }
            ].map((facility, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-3xl p-6">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${facility.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-2">{facility.name}</h3>
                <p className="text-gray-600 font-semibold mb-2">{facility.type}</p>
                <p className="text-gray-600 text-sm">{facility.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Equipment We Purchase in Sioux Falls
            </h2>
            <p className="text-gray-600 text-xl">
              Specialized in ethanol production and food processing equipment
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: 'Process Valves',
                icon: 'ri-settings-3-line',
                items: ['Ball Valves', 'Gate Valves', 'Butterfly Valves', 'Check Valves']
              },
              {
                title: 'Flow Instruments',
                icon: 'ri-bar-chart-line',
                items: ['Flow Meters', 'Turbine Meters', 'Magnetic Meters', 'Mass Flow']
              },
              {
                title: 'Control Systems',
                icon: 'ri-cpu-line',
                items: ['PLCs', 'HMIs', 'Controllers', 'Transmitters']
              },
              {
                title: 'Safety Equipment',
                icon: 'ri-shield-check-line',
                items: ['Relief Valves', 'Safety Systems', 'Gas Detection', 'Alarms']
              }
            ].map((category, index) => (
              <div key={index} className="bg-white rounded-3xl p-6">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${category.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{category.title}</h3>
                <ul className="space-y-2">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-[#1B3A5F] mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Advantages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Why Sioux Falls Facilities Choose Us
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: 'Regional Expertise',
                icon: 'ri-map-pin-line',
                description: 'Deep understanding of Eastern South Dakota\'s ethanol production and food processing industries with specialized knowledge of regional equipment standards.'
              },
              {
                title: 'Fast Response',
                icon: 'ri-time-line',
                description: 'Same-day site visits throughout Sioux Falls metro area with 24-hour quotes for all equipment types and project sizes.'
              },
              {
                title: 'Professional Service',
                icon: 'ri-award-line',
                description: 'Licensed, insured, and experienced team handling everything from small instrument lots to complete facility decommissioning projects.'
              }
            ].map((advantage, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-3xl p-8 text-center">
                <div className="w-20 h-20 bg-[#1B3A5F] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${advantage.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{advantage.title}</h3>
                <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Related Markets */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Other South Dakota Markets We Serve
            </h2>
            <p className="text-gray-600 text-xl">
              Comprehensive coverage across South Dakota
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-8">
            <Link
              to="/rapid-city"
              className="bg-white rounded-2xl p-6 hover:shadow-lg transition-all duration-300 flex items-center justify-between group"
            >
              <div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-1">Rapid City</h3>
                <p className="text-gray-600">Western South Dakota Hub</p>
              </div>
              <i className="ri-arrow-right-line text-[#1B3A5F] text-2xl group-hover:translate-x-2 transition-transform"></i>
            </Link>
          </div>

          <div className="text-center">
            <Link
              to="/south-dakota"
              className="inline-flex items-center text-[#1B3A5F] font-semibold text-lg hover:underline"
            >
              View All South Dakota Cities
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-white text-4xl font-bold mb-6">
            Get Your Sioux Falls Equipment Quote Today
          </h2>
          <p className="text-gray-200 text-xl mb-10">
            Fast, professional service for all your surplus equipment needs in Eastern South Dakota
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link
              to="/contact"
              className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap"
            >
              REQUEST A QUOTE
            </Link>
            <a
              href="tel:214-854-5638"
              className="border-2 border-white text-white px-10 py-4 rounded-full text-xl font-semibold hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 flex items-center justify-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              (214) 854-5638
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SiouxFalls;
